import _ from 'lodash';
import Handlebars from 'handlebars';
import moment from "moment";

const defaultTimezone = moment.tz.guess();

export function renderLocation(lat, long) {
  if (!lat || !long) return ''
  
  return new Handlebars.SafeString(
    `<div 
      style="cursor: pointer;" 
      class="show-map-marker" 
      data-lat=${lat} 
      data-long=${long}>
        At location [${lat.toFixed(6)}, ${long.toFixed(6)}] 
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.com/maps/search/?api=1&query=${lat},${long}">Google Map</a>
      </div>`)
}

export function lowerCase(text) {
  return text.toLowerCase();
}

export function upperCase(text) {
  return text.toUpperCase();
}

export function removeDash(text) {
  return text.replaceAll(['_'], '');
}

export function replaceDash(text) {
  return text.replaceAll(['_'], ' ');
}

export function convertMeterToMileString(val) {
  if(!val || isNaN(val)) return '';

  return `${convertMeterToMile(+val, 1)}`;
}

export function convertSecondToHour(val) {
  if(!val || isNaN(val)) return '';

  return secondTohour(+val);
}

export function capitalizeText(val) {
  if(!val) return '';

  return val.replace(/(^\w|\s\w)(\S*)/g, (_,m1,m2) => m1.toUpperCase() + m2.toLowerCase());
};

export function splitText(val, options) {
  if (!val) return '';
  const symbol = _.isEmpty(options && options.hash && options.hash.symbol) ? ',' : options.hash.symbol;
  const valSplit = val.split(symbol);
  return !Array.isArray(valSplit) ? [] : valSplit.map(item => item.trim());
}

export function formatDateTime(date, timezone, format) {
  const tz = timezone || defaultTimezone;

  if (!date) return '';

  return `${moment.tz(date, tz).format(format || `MM/DD/YYYY HH:mm z`)}`;
}

export function when(operand_1, operator, operand_2, options) {
  operator = operator || 'eq';
  
  const operators = {
   'eq': function(l,r) { return l == r; },
   'ne': function(l,r) { return l != r; },
   'gt': function(l,r) { return Number(l) > Number(r); },
   'gte': function(l,r) { return Number(l) >= Number(r); },
   'lt': function(l,r) { return Number(l) < Number(r); },
   'lte': function(l,r) { return Number(l) <= Number(r); },
  };

  const result = operators[operator](operand_1,operand_2);

  if(result) return options.fn(this);
  else return options.inverse(this);
}

export function whenAnd(opts) {
  let isTrue = true;
  Object.keys(opts.hash).forEach(k => {
    if (_.get(opts.data.root, k) != opts.hash[k]) {
      isTrue = false;
    }
  });

  if (isTrue)
    return opts.fn(this); 
  else
    return opts.inverse(this);
}

export function whenOr(opts) {
  let isTrue = false;
  Object.keys(opts.hash).forEach(k => {
    if (_.get(opts.data.root, k) === opts.hash[k]) {
      isTrue = true;
    }
  });

  if (isTrue)
    return opts.fn(this); 
  else
    return opts.inverse(this);
}

const secondTohour = minute => {
  if (!minute) return '';
  const duration = moment.duration(minute, 'seconds');

  //calculate hours
  const hh = duration.years() * (365 * 24) + duration.months() * (30 * 24) + duration.days() * 24 + duration.hours();

  //get minutes
  const mm = duration.minutes();
  if (hh === 0) return mm + 'mins';
  //return total time in hh:mm format
  return hh + 'hrs ' + mm + 'mins';
};

const MILE_TO_METER = 1609.34;
const convertMeterToMile = (val, decimal_number = 1) => {
  return (val / MILE_TO_METER).toFixed(decimal_number);
};